module.exports = __webpack_public_path__ + "img/GP3_Germany_CircularBlackForest.bf648121.webp";